import {IComponentOptions, IFormController, ILogService} from "angular";
import {PriorCourseUnit} from "../model/PriorCourseUnit";
import {Application} from "../model/Application";
import * as _ from "lodash";
import {PriorCourse} from "../model/PriorCourse";

class AddUnitComponentController {

    public resolve: any;
    public close: any;
    public dismiss: any;
    public form: IFormController;
    public unit: PriorCourseUnit;
    public application: Application;
    public showErrors: boolean = false;
    public priorCourse: PriorCourse;

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    public $onInit() {
        this.$log.debug("AddUnitComponentController.$onInit()");
        this.$log.debug("resolve is %o", this.resolve);
        this.application = this.resolve.application;
        this.priorCourse = this.resolve.priorCourse;
        if (this.resolve.priorUnit !== undefined && this.resolve.priorUnit != null) {
            this.unit = this.resolve.priorUnit;
        } else {
            this.unit = new PriorCourseUnit();
            this.unit.unitId = this.uuidv4();
        }
    }

    public uuidv4() {
        let result;
        let i;
        let j;
        result = "";
        for (j = 0; j < 32; j++) {
            if (j === 8 || j === 12 || j === 16 || j === 20) {
                result = result + "-";
            }
            i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
            result = result + i;
        }
        return result;
    }

    public addUnit() {
        this.showErrors = false;
        if (!this.form.$valid) {
            this.$log.error("Wtf", this.form.$error);
            this.showErrors = true;
            this.setDirty(this.form.$$controls);
        } else {
            if (this.priorCourse.units === undefined) {
                this.priorCourse.units = [];
            }

            if (this.priorCourse.units.indexOf(this.unit) >= 0) {
                this.priorCourse.units[this.priorCourse.units.indexOf(this.unit)] = this.unit;
            } else {
                this.priorCourse.units.push(this.unit);
            }

            this.close({$value: this.priorCourse});
        }
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }

    public setDirty(controls) {
        _.forEach(controls, (control) => {
            if (control.$setTouched !== undefined) {
                control.$setTouched();
            }

            if (control.$setDirty !== undefined) {
                control.$setDirty();
            }

            if (control.$$controls !== undefined) {
                this.setDirty(control.$$controls);
            }
        });
    }
}

export const AddUnitComponent: IComponentOptions = {
    bindings: {
        resolve: "=",
        close: "&",
        dismiss: "&",
    },
    controller: AddUnitComponentController,
    template: require("./add-unit.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/add-unit.component.ts